var style = {"z-rating":"z-rating","z-brand-theme-zooplus":"z-brand-theme-zooplus","z-brand-theme-bitiba":"z-brand-theme-bitiba","z-rating--sm":"z-rating--sm","z-rating--lg":"z-rating--lg","z-rating--full-width":"z-rating--full-width","z-rating__star-wrap":"z-rating__star-wrap","z-rating__star":"z-rating__star","z-rating__star--full":"z-rating__star--full","z-rating__count":"z-rating__count"};

export { style as default };
//# sourceMappingURL=Rating.module.scss.js.map
